import { Navigate, type RouteObject } from "react-router-dom";
import { LoginPage } from "@/modules/auth/pages/LoginPage";
import { DashboardPage } from "@/modules/dashboard/pages/DashboardPage";
import { WeddingHallsPage } from "@/modules/wedding-halls/pages/WeddingHallsPage";
import { WeddingHallDetailPage } from "@/modules/wedding-halls/pages/WeddingHallDetailPage";
import { NvrsPage } from "@/modules/nvr/pages/NvrsPage";
import { NvrDetailPage } from "@/modules/nvr/pages/NvrDetailPage";
import { CamerasPage } from "@/modules/cameras/pages/CamerasPage";
import { ArtistsPage } from "@/modules/artists/pages/ArtistsPage";
import { ArtistDetailPage } from "@/modules/artists/pages/ArtistDetailPage";
import { EventsPage } from "@/modules/events/pages/EventsPage";
import { EventDetailPage } from "@/modules/events/pages/EventDetailPage";
import { SnapshotsPage } from "@/modules/snapshots/pages/SnapshotsPage";
import { UsersPage } from "@/modules/users/pages/UsersPage";
import { IntegrationsPage } from "@/modules/integrations/pages/IntegrationsPage";
import { AuthLayout } from "@/shared/components/layouts/AuthLayout";
import { MainLayout } from "@/shared/components/layouts/MainLayout";
import { ProtectedRoute } from "./ProtectedRoute";

export const routes: RouteObject[] = [
	// Public routes
	{
		path: "/login",
		element: <AuthLayout />,
		children: [{ index: true, element: <LoginPage /> }],
	},

	// Protected routes
	{
		path: "/",
		element: (
			<ProtectedRoute>
				<MainLayout />
			</ProtectedRoute>
		),
		children: [
			{ index: true, element: <Navigate to="/dashboard" replace /> },
			{ path: "dashboard", element: <DashboardPage /> },

			// To'yxonalar (create/edit — Drawer ichida)
			{ path: "wedding-halls", element: <WeddingHallsPage /> },
			{ path: "wedding-halls/:id", element: <WeddingHallDetailPage /> },

			// NVR & Kameralar (create/edit — Drawer ichida)
			{ path: "nvrs", element: <NvrsPage /> },
			{ path: "nvrs/:id", element: <NvrDetailPage /> },
			{ path: "cameras", element: <CamerasPage /> },

			// Sanatkorlar (create/edit — Drawer ichida)
			{ path: "artists", element: <ArtistsPage /> },
			{ path: "artists/:id", element: <ArtistDetailPage /> },

			// Tadbirlar
			{ path: "events", element: <EventsPage /> },
			{ path: "events/:id", element: <EventDetailPage /> },

			// Snapshotlar
			{ path: "snapshots", element: <SnapshotsPage /> },

			// Admin (create/edit — Drawer ichida)
			{ path: "users", element: <UsersPage /> },
			{ path: "integrations", element: <IntegrationsPage /> },
		],
	},

	// 404
	{ path: "*", element: <Navigate to="/" replace /> },
];
